import { apiClient } from './client';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  Organization,
  CreateOrganizationRequest,
  SwitchOrgResponse,
} from '@/types/auth';

export const authApi = {
  register: (data: RegisterRequest) =>
    apiClient.post<{ userId: string; email: string }>('/auth/register', data),

  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/auth/login', data),

  switchOrg: (orgId: string) =>
    apiClient.post<SwitchOrgResponse>(`/auth/switch-org/${orgId}`),
};

export interface ProfileResponse {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  displayName: string;
  taskRemindersEnabled: boolean;
  token?: string; // returned by UpdateProfile so the frontend can refresh the JWT immediately
}

export const profileApi = {
  get: () => apiClient.get<ProfileResponse>('/api/profile'),
  update: (data: { firstName?: string; lastName?: string }) =>
    apiClient.put<ProfileResponse>('/api/profile', data),
  changeEmail: (newEmail: string) =>
    apiClient.put<{ email: string; token: string }>('/api/profile/email', { newEmail }),
  updateNotifications: (data: { taskRemindersEnabled: boolean }) =>
    apiClient.put<{ taskRemindersEnabled: boolean }>('/api/profile/notifications', data),
  deleteAccount: (password: string) =>
    apiClient.delete('/api/profile/account', { password }),
};

export const passwordResetApi = {
  forgotPassword: (email: string) =>
    apiClient.post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (email: string, token: string, newPassword: string) =>
    apiClient.post<{ message: string }>('/auth/reset-password', { email, token, newPassword }),
};

export const organizationApi = {
  list: () => apiClient.get<Organization[]>('/orgs'),

  create: (data: CreateOrganizationRequest) =>
    apiClient.post<Organization>('/orgs', data),
};
